const MenuTypes = {
    TOGGLE_MENU: 'TOGGLE_MENU'
}

export default MenuTypes;